<div class="modal-header">
    <div class="modal-title">
        <h2 mat-dialog-title>Trend</h2>
    </div>
    <div class="header-buttons">
        <button *ngIf="!isMainFcstWalk" (click)="onPin()" class="btn btn-icon btn-transparent" tabindex="-1">
            <span class="material-icons-outlined">push_pin</span>
        </button>
        <button (click)="onClose()" class="btn btn-icon btn-transparent" tabindex="-1">
            <span class="material-icons-outlined">close</span>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <div *ngIf="!dataLoaded" class="skeleton-main">
        <div class="skeleton skeleton-box-big"></div>
    </div>
    <app-trend
        *ngIf="dataLoaded"
        [model]="benchmarksModel"
        [projectId]="data.projectId"
        [viewId]="data.viewId"
        [tabId]="data.tabId"
        [cardIndex]="data.cardIx"
        [isMainfcstwalk]="isMainFcstWalk"
        [tabIx]="data.tabIx"
        [seqMode]="seqMode"
        (seqModeChange)="onSeqModeChange($event)"
        (formCompChanged)="onFormCompChanged($event)"
        (saved)="onFcstSaved($event)">
    </app-trend>
</mat-dialog-content>
